import { Icon, Toolbar } from '@material-ui/core';
import { Button } from '@ui';
import React from 'react';
import icon from '../../assets/img/AddShoppingCart.svg';
import { usePaymentProviderContext } from '../../Session';
import { useShopTokenContext } from '../../Session/ShopTokenContext';
import { Paper } from '../common/Paper';
import { PaymentProvider } from '../services/AuthServiceTypes';
import { CreateLicensePayload, useWebshop } from '../webshop';

const CartIcon = () => (
  <Icon>
    <img src={icon} alt={'AddToShoppingCart icon'} />
  </Icon>
);

const buildMessagePayload = async (
  account: PaymentProvider | undefined,
  bearerToken: string,
): Promise<CreateLicensePayload> => {
  if (!account) {
    throw new Error(`A payment maccount is required for purchasing a new license`);
  }

  const { paymentMethod, currency, billToContact, vatId } = account;

  if (!paymentMethod) {
    throw new Error(`A payment method is required for purchasing a new license`);
  }

  return {
    bearerToken,
    contact: {
      ...billToContact,
      email: billToContact.workEmail,
      address: billToContact.address1,
      vatId,
    },
    currency,
    paymentMethod,
  };
};

export type NewLicenseKeyButtonProps = {
  onComplete: (message: { type: 'LicenseCreated' }) => void;
};

export const NewLicenseKey: React.FC<NewLicenseKeyButtonProps> = ({ onComplete }) => {
  const { paymentProvider } = usePaymentProviderContext();
  const { shopToken } = useShopTokenContext();
  const { status, createLicense } = useWebshop();

  const onClick = () =>
    void buildMessagePayload(paymentProvider, shopToken?.token ?? '')
      .then(createLicense)
      .then(onComplete)
      .catch(console.error);

  if (status === 'error') {
    return null;
  }

  return (
    <Paper variant={'outlined'} component={Toolbar}>
      <Button
        disabled={status !== 'loaded'}
        color='secondary'
        variant='outlined'
        size='small'
        startIcon={<CartIcon />}
        onClick={onClick}
      >
        New License Key
      </Button>
    </Paper>
  );
};
